import * as z from 'zod/v4-mini';

const emailSchema = z.string().check(z.email());

export function isValidEmail(value: string): boolean {
	return emailSchema.safeParse(value.trim()).success;
}
